import { UserRole } from 'shared/types';

// First route to land on for each role. After the 2026-05 unification the
// "contractor" path is no longer driven by role — provider users land on
// /contractor/dashboard via the same company_admin / client_staff roles when
// their active company is `proveedor`. The RoleBasedRedirect component picks
// up the company-type signal at the call site.
export const getDefaultRouteForRole = (
  role: UserRole,
  companyType?: 'cliente' | 'proveedor',
): string => {
  switch (role) {
    case UserRole.SUPER_ADMIN:
      return '/inicio';

    case UserRole.SAFETY_STAFF:
      return '/inicio';

    case UserRole.COMPANY_ADMIN:
      // Every company_admin (cliente OR proveedor) lands on /my-company.
      // CompanyDetail itself swaps in ProviderCompanyDetail when the
      // active company's `companyType === 'proveedor'`, so the URL is
      // unified but the rendered page is role-appropriate.
      return '/my-company';

    case UserRole.CLIENT_APPROVER:
      return '/approver/dashboard';

    case UserRole.CLIENT_STAFF:
      // Provider client_staff still get /contractor/dashboard (a worker-
      // facing view with verification status + clients linked). Client-
      // side staff land on /staff/inicio.
      return companyType === 'proveedor' ? '/contractor/dashboard' : '/staff/inicio';

    case UserRole.SECURITY:
      return '/seguridad/inicio';

    default:
      return '/dashboard';
  }
};
